import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detail_two-column",
  "use": "icon-detail_two-column-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-detail_two-column\"><g stroke=\"currentColor\" fill=\"transparent\"><path d=\"M22.972 22h0H-3a2 2 0 01-2-2V-2a2 2 0 012-2h25.94\" stroke-width=\".8\" /><g><circle cx=\"5.5\" cy=\"3.5\" r=\"1\" /><circle cx=\"12.75\" cy=\"3.5\" r=\"1\" /><path stroke-width=\"1.5\" stroke-linecap=\"round\" d=\"M5.5 7.765V16M12.75 7.765V16\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol